/* eslint-disable camelcase */
import { ANALYTICS_CATEGORIES, SNOWPLOW_BACKEND_ENTITIES, SNOWPLOW_EVENTS } from 'Services/analytics/analytics.const';

import { getSnowplowEventPayload, logAnalyticsEvent } from '../../analytics';
import type { SnowplowBackendTriggerEventSchema } from '../../analytics.types';

import { basePaymentsEvent } from './base/basePaymentEvent';
import type { PaymentEventProps } from './base/basePaymentEvent.type';

const {
	PAYMENTS: { OTP },
} = ANALYTICS_CATEGORIES;

export function otpEvents<CustomData extends UnknownShapeObject>(props: PaymentEventProps<CustomData>): void {
	basePaymentsEvent({
		category: OTP,
		...props,
	});
}

interface OtpEventsBackendTrigger {
	action: string;
	backendService: string;
	label: string;
}

export const otpEventsBackendTrigger = ({ action, backendService, label }: OtpEventsBackendTrigger): void => {
	const eventPayload = getSnowplowEventPayload<SnowplowBackendTriggerEventSchema>({
		action,
		backend_entity: SNOWPLOW_BACKEND_ENTITIES.PAYMENTS,
		backend_service: backendService,
		schemaName: SNOWPLOW_EVENTS.BACKEND_TRIGGER.SCHEMA,
		success: true,
		value: label,
		version: SNOWPLOW_EVENTS.BACKEND_TRIGGER.VERSION,
	});

	logAnalyticsEvent({ eventPayload });
};
